<template>
    <img
        v-if="showImage"
        :src="image.url"
        class="w-full h-full object-cover"
        @error.native="onImgError"/>
    <div v-else class="w-full h-full inline-flex justify-center items-center">
        <svg  fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-4/5 h-4/5">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
        </svg>
    </div>
</template>

<script>

export default {

    name: "ProfileImage",

    props: {
        image: {}
    },

    data() {
        return {
            hasImageError: false
        }
    },

    methods: {
        onImgError() {
            this.hasImageError = true
        }
    },

    computed: {
        showImage() {
            return this.image && this.image.url && !this.hasImageError;
        }
    },

    watch: {
        image() {
            this.hasImageError = false;
        }
    }
};

</script>
